import { ArrowUpRight } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { AddToBag } from "@/components/AddToBag";
import { BRUSHES, BRUSH_COLLECTION, BRUSH_GROUPS, collectionUrl, formatINR, productUrl } from "@/data/catalog";
import { useLiveProduct } from "@/lib/live";

const Row = ({ brush: base, index, onPick }) => {
  const b = useLiveProduct(base);
  return (
    <li className="grid grid-cols-[auto_1fr_auto] items-center gap-4 border-b border-white/10 py-3" data-testid={`brush-drawer-row-${b.id}`}>
      <button onClick={() => onPick(index)} aria-label={`Show ${b.code} in the atelier`} className="h-20 w-12 shrink-0 overflow-hidden rounded-md">
        <img src={b.img} alt="" loading="lazy" className="h-full w-full object-cover" />
      </button>
      <div className="min-w-0">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-champagne">{b.code}</p>
        <a href={productUrl(b.handle)} className="block truncate font-display text-xl leading-tight text-cream hover:text-champagne">{b.name}</a>
        <p className="truncate text-xs text-stone">{b.best}</p>
      </div>
      <div className="text-right">
        <p className="text-sm text-cream">{formatINR(b.price)}</p>
        {b.compare > b.price && <p className="text-[11px] text-stone line-through">{formatINR(b.compare)}</p>}
        <AddToBag p={b} testId={`brush-drawer-add-${b.id}`} className="mt-1 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.16em] text-champagne hover:text-cream" soldOutLabel="Sold out">
          Add
        </AddToBag>
      </div>
    </li>
  );
};

/** Every WSP brush, grouped, shoppable - opened from the atelier's "See all" button. */
export const BrushDrawer = ({ open, onOpenChange, onPick }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="right" className="w-[92vw] max-w-md overflow-y-auto border-gold/20 bg-ink text-cream" data-lenis-prevent data-testid="brush-drawer">
      <SheetTitle className="font-mono text-xs uppercase tracking-[0.3em] text-champagne">WINK Signature Pro · {BRUSHES.length} brushes</SheetTitle>
      {BRUSH_GROUPS.map((g) => (
        <div key={g} className="mt-8">
          <p className="font-display text-2xl text-cream">{g}</p>
          <ul className="mt-2">
            {BRUSHES.map((b, i) => (b.group === g ? <Row key={b.id} brush={b} index={i} onPick={onPick} /> : null))}
          </ul>
        </div>
      ))}
      <a href={collectionUrl(BRUSH_COLLECTION)} data-testid="brush-drawer-view-all" className="btn-ghost mt-8 w-full justify-center">
        Open the brush collection <ArrowUpRight className="h-4 w-4" />
      </a>
    </SheetContent>
  </Sheet>
);
